export class ResponseModel {
    isSuccess: boolean;
    message: string;
    data: any;
    dataCount: number;
    exception: object;
}


// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/models/response.model.ts